import {
  AttachFile,
  DeleteOutlined,
  ErrorOutlineOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import RadioButton from "components/UI/radioButton/radioButton";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

// import RiskDrawer from "../../NewQuestionTabComps/RightSection/riskDrawer/RiskDrawer";
// import { gql_get_risk_auto_populate } from "redux/actions/vendorActions/vendorAction";

const SingleChoiceWithMultiFeatures = ({
  question,
  options,
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer = ()=>{},
  questionType,
  event,
  comment,
  checkBoxOption,
  setCheckBoxOption,
  usingQues,
  linkageAnswer,
  questionId,
  sectionTitle,
  questionTitle,
  selectedQues,
  hasAttachedDocument,
  configuration
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [justification, setJustification] = useState("");
  const [file, setFile] = useState(null);
  const [commentBox, setCommentBox] = useState("");
  const [option, setOption] = useState({});
  const [newOption, setNewOption] = useState("");
  const [newWeightage, setNewWeightage] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [riskData, setRiskData] = useState({
    description: "",
    enableCompensationControl: false,
    finding: "",
    risk: "",
    severity: "",
  });

  const [optionIndex, setOptionIndex] = useState(null);
  const [compensationStatement, setCompensationStatement] = useState("");
  const isEditing = selectedQues?._id === usingQues?._id;
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  // const { riskAutoPopulate } = useSelector((state) => state?.brmData);

  const handleOptionChange = (event) => {
    const optionValue = event.target.value;
    setSelectedOption(optionValue);
  };

  const handleRiskAutoPopulate = (option) => {
    // dispatch(gql_get_risk_auto_populate(option, questionTitle, sectionTitle));
  };

  // useEffect(() => {
  //   if (riskAutoPopulate) {
  //     setRiskData({
  //       description: riskAutoPopulate?.Descriptions || "",
  //       finding: riskAutoPopulate?.Findings || "",
  //       risk: riskAutoPopulate["Risk Factors"][0] || "",
  //       severity: riskAutoPopulate["Severity levels"] || "",
  //     });
  //   }
  // }, [riskAutoPopulate]);

  const customOptions = [
    // { option: "Option 1", weightage: 2 },
    // { option: "Option 2", weightage: 3 },
  ];

  useEffect(() => {
    // const exceptions = [
    //   ...radioOption[SUB_QUESTION_0_10],
    //   ...radioOption[SUB_QUESTION_QUALITY],
    //   ...radioOption[SUB_QUESTION_SATISFACTION],
    //   ...radioOption[SUB_QUESTION_LIKERT],
    //   ...radioOption[SUB_QUESTION_FREQUENCY],
    //   ...radioOption[SUB_QUESTION_PERFORMANCE],
    //   ...radioOption[SUB_QUESTION_IMPORTANCE],
    //   ...radioOption[SUB_QUESTION_EMOTIONS],
    // ];

    if (checkBoxOption?.length === 0 && !submittedAnswer) {
      if (
        usingQues?.questionType === "ZERO_TO_TEN" ||
        usingQues?.questionType === "LIKERT" ||
        usingQues?.questionType === "SATISFACTION" ||
        usingQues?.questionType === "QUALITY" ||
        usingQues?.questionType === "FREQUENCY" ||
        usingQues?.questionType === "PERFORMANCE" ||
        usingQues?.questionType === "IMPORTANCE" ||
        usingQues?.questionType === "EMOTIONS" ||
        usingQues?.questionType === "TABLE"
      ) {
        setCheckBoxOption(customOptions);
      } else {
        setCheckBoxOption(options || customOptions);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddOption = () => {
    if (newOption.trim() && newWeightage.trim()) {
      setCheckBoxOption([
        ...checkBoxOption,
        {
          option: newOption.trim(),
          weight: parseFloat(newWeightage),
          justification: true,
          documentUpload: true,
        },
      ]);
      setNewOption("");
      setNewWeightage("");
    }
  };

  const handleWeightageChange = (event) => {
    setNewWeightage(event.target.value);
  };

  const handleNewOption = (event) => {
    setNewOption(event.target.value);
  };

  const handleRemoveOption = (index) => {
    setCheckBoxOption(checkBoxOption?.filter((_, i) => i !== index));
  };

  const handleOption = (opt, i) => {
    setOption(opt);

    handleQuesAnswer({
      obj: { ...opt, comment: commentBox },
      realQuestion: question,
    });

    handleQuesAnswer({
      obj: { ...opt, comment: commentBox },
      realQuestion: question,
    });

    if (isFrom !== "surveyCreation") {
    }
    setOptionIndex(i);
  };

  const handleJustificationChange = (event) => {
    setJustification(event.target.value);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // useEffect(() => {
  //   if (isFrom === "taskSection") {
  //     const obj = {
  //       value: selectedOption || submittedAnswer?.value,
  //       justification,
  //       document: file,
  //       weight: option?.weight || submittedAnswer?.weight,
  //       comment: commentBox || submittedAnswer?.comment,
  //       answerLogic: option?.answerLogic || submittedAnswer?.answerLogic,
  //       // riskCompensationStatement: compensationStatement,
  //     };

  //     handleQuesAnswer({ obj, realQuestion: question });
  //   }
  // }, [selectedOption, justification, file, compensationStatement, commentBox]);

  // useEffect(() => {
  //   return () => {
  //     if (isFrom === "taskSection") {
  //       setFile(null);
  //       setJustification("");
  //     }
  //   };
  // }, [selectedOption]);

  const initialized = useRef(false);

  useEffect(() => {
    if (
      !initialized.current &&
      submittedAnswer &&
      (submittedAnswer?.length > 0 || Object.keys(submittedAnswer).length > 0)
    ) {
      setSelectedOption(submittedAnswer[0]?.option || submittedAnswer?.value);
      setJustification(
        submittedAnswer[0]?.justificationText ||
          submittedAnswer[0]?.justification ||
          submittedAnswer?.justification
      );
      setFile(
        submittedAnswer?.[0]?.files?.length > 0 &&
          submittedAnswer?.[0]?.files?.[0]
      );
      setCommentBox(submittedAnswer[0]?.comment || submittedAnswer?.comment);
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);

      initialized.current = true;
    }
  }, []);
  const handleChange = (type, value, extra = null, index = null) => {
    if (type === "option") {
      setSelectedOption(value);
      setOption(extra || {});
      setOptionIndex(index);
      handleQuesAnswer({
        obj: {
          ...extra,
          comment: commentBox,
          supporting_document: attachDocument,
        },
        realQuestion: question,
      });
    }

    if (type === "comment") {
      setCommentBox(value);
      handleQuesAnswer({
        obj: { ...option, comment: value, supporting_document: attachDocument },
        realQuestion: question,
      });
    }

    if (type === "document") {
      setAttachDocument(value);

      handleQuesAnswer({
        obj: {
          ...option,
          comment: commentBox,
          supporting_document:
            type === "document" && value === null ? value : attachDocument,
          document: type === "document" ? value : attachDocument,
          documentMetaData:
            type === "document"
              ? {
                  ques_id: question?._id,
                  name: value?.name,
                  is_supporting_document: true,
                  type: value?.type,
                }
              : null,
        },
        realQuestion: question,
      });
    }
  };

  // const handleToggleRiskDrawer = () => {
  //   setToggleDrawer(false);
  // };

  // const handleRiskData = (e) => {
  //   setCheckBoxOption((prev) =>
  //     prev.map((item, i) => {
  //       if (i === optionIndex) {
  //         return {
  //           ...item,
  //           questionRisk: {
  //             ...item?.questionRisk,
  //             [e.target.name]: e.target.value ? e.target.value : "",
  //             // description:
  //             //   e.target.name === "description" ? e.target.value : "",
  //             // finding: e.target.name === "finding" ? e.target.value : "",
  //             // risk: e.target.name === "risk" ? e.target.value : "",
  //             // severity: e.target.name === "severity" ? e.target.value : "",
  //             enableCompensationControl: e.target.checked ? true : false,
  //           },
  //         };
  //       }
  //       return item;
  //     })
  //   );

  //   if (e.target.name === "enableCompensationControl") {
  //     setRiskData((prev) => ({
  //       ...prev,
  //       [e.target.name]: e.target.checked,
  //     }));
  //   } else {
  //     setRiskData((prev) => ({
  //       ...prev,
  //       [e.target.name]: e.target.value,
  //     }));
  //   }
  // };

  const handleMapRiskData = (i) => {
    if (isFrom === "surveyCreation" && checkBoxOption[i]?.questionRisk) {
      setRiskData(checkBoxOption[i]?.questionRisk);
    }
  };

  const severity = (type, color) => {
    if (type === "bg") {
      if (color === "yellow") {
        return "#ffeeba";
      } else if (color === "green") {
        return "#BFE2CD";
      } else {
        return "#EDCAC6";
      }
    } else {
      if (color === "yellow") {
        return "#856404";
      } else if (color === "green") {
        return "#154328";
      } else {
        return "#52231D";
      }
    }
  };

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" }, // Adjust placeholder font size
    },
  };

  const labelSize = {
    style: { fontSize: "14px" }, // Adjust label font size
  };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <FormControl
        component="fieldset"
        sx={
          configuration
            ? {
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                padding: 2,
                // maxWidth: 700,
                margin: "20px auto",
                backgroundColor: "#ebf1f8",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",             
                width: "100%"
              }
            : { width: "100%" }
        }
      >
        {(checkBoxOption || options)?.length > 0 ? (
          <RadioGroup value={selectedOption} onChange={handleOptionChange}>
            {(checkBoxOption || options)?.map((option, index) => (
              <>
                <Box
                  key={index}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <FormControlLabel
                    data-testid={`radio-${option?.option}`}
                    key={option?.option}
                    value={option?.option}
                    control={<RadioButton color="primary" />}
                    label={option?.option}
                    style={{ pointerEvents: event }}
                    onClick={() =>
                      handleChange("option", option?.option, option, index)
                    }
                  />

                  {isFrom === "surveyCreation" && isEditing && (
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      gridGap={"20px"}
                      style={{ marginRight: "10px" }}
                    >
                      <ErrorOutlineOutlined
                        size="small"
                        onClick={() => {
                          setToggleDrawer(true);
                          setOptionIndex(index);
                          handleMapRiskData(index);
                          if (!option?.questionRisk) {
                            handleRiskAutoPopulate(option?.option);
                          }
                        }}
                        style={{
                          color: !option?.questionRisk ? "#3374B9" : "#B81D13",
                          cursor: "pointer",
                        }}
                      />

                      <AiOutlineDelete
                        size={22}
                        onClick={() => handleRemoveOption(index)}
                        style={{ color: "#B81D13", cursor: "pointer" }}
                      />
                    </Box>
                  )}
                </Box>
                {((index === optionIndex &&
                  option?.questionRisk &&
                  isFrom !== "surveyCreation") ||
                  (submittedAnswer?.length > 0 &&
                    submittedAnswer?.[0]?.option === option?.option)) && (
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    gridGap={7}
                    mb={1}
                    ml={3}
                  >
                    {/* <Typography>
                        Finding: <strong>{option?.questionRisk?.finding}</strong>
                      </Typography>
                      <Typography>
                        Description:{" "}
                        <strong>{option?.questionRisk?.description}</strong>
                      </Typography>
                      <Typography>
                        Severity:{" "}
                        <Chip
                          label={
                            <strong>{option?.questionRisk?.severity}</strong>
                          }
                          style={{
                            color:
                              option?.questionRisk?.severity === "HIGH"
                                ? severity("text", "red")
                                : option?.questionRisk?.severity === "MEDIUM"
                                ? severity("text", "yellow")
                                : severity("text", "green"),
                            backgroundColor:
                              option?.questionRisk?.severity === "HIGH"
                                ? severity("bg", "red")
                                : option?.questionRisk?.severity === "MEDIUM"
                                ? severity("bg", "yellow")
                                : severity("bg", "green"),
                          }}
                        ></Chip>
                        
                      </Typography> */}
                    {(option?.questionRisk?.enableCompensationControl ||
                      submittedAnswer?.[0]?.riskCompensationStatement) && (
                      <TextField
                        fullWidth
                        id="comment"
                        label="Compensation Statement"
                        variant="outlined"
                        multiline
                        minRows={2}
                        // placeholder="Compensation comment"
                        style={{ marginTop: "10px" }}
                        value={compensationStatement}
                        // defaultValue={usingQues?.commentBox}
                        onChange={(e) =>
                          setCompensationStatement(e.target.value)
                        }
                      />
                    )}
                  </Box>
                )}
              </>
            ))}
          </RadioGroup>
        ) : (
          <Typography style={{ marginBottom: 10 }}>Add some options</Typography>
        )}
        {isFrom === "surveyCreation" && isEditing && (
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 10,
              alignItems: "center",
              marginTop: 5,
            }}
          >
            <TextField
              label="New Option"
              variant="outlined"
              value={newOption}
              onChange={handleNewOption}
              size="small"
            />
            <TextField
              label="Weightage"
              variant="outlined"
              type="number"
              value={newWeightage}
              onChange={handleWeightageChange}
              size="small"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddOption}
              disabled={newOption === "" || newWeightage === ""}
              size="small"
            >
              Add Option
            </Button>
          </Box>
        )}
      </FormControl>
      {((selectedOption &&
        options?.find((option) => option?.option === selectedOption)
          ?.justification === true) ||
        questionType === "SINGLE_CHOICE_TEXT" ||
        questionType === "SINGLE_CHOICE_TEXT_DOC") && (
        <TextField
          id="justification"
          label="Justification"
          variant="outlined"
          value={justification}
          onChange={handleJustificationChange}
          fullWidth
          multiline
          minRows={4}
          margin="normal"
          style={{ pointerEvents: event }}
          InputLabelProps={labelSize}
          inputProps={placeholderSize}
        />
      )}
      {((selectedOption &&
        options?.find((option) => option?.option === selectedOption)
          ?.documentUpload === true) ||
        questionType === "SINGLE_CHOICE_DOC" ||
        questionType === "SINGLE_CHOICE_TEXT_DOC") && (
        <Box
          width="100%"
          style={{
            margin: "26px 5px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            inputRef.current?.click();
          }}
        >
          <AttachFile
            style={{ backgroundColor: "#ced4da", padding: 4 }}
            color="disabled"
          />
          {submittedAnswer?.length > 0 &&
          (isFrom === "submissionSection" || isFrom === "approvalSection") ? (
            <Box
              border={1}
              borderRadius={4}
              p={1}
              borderColor={"#cececece"}
              ml={2}
            >
              {submittedAnswer?.[0]?.files?.[0]?.url === null ||
              !submittedAnswer?.[0]?.files ? (
                <Typography variant={"body2"}>
                  No document has been uploaded
                </Typography>
              ) : (
                <a
                  href={submittedAnswer?.[0]?.files?.[0]?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#999" }}
                >
                  {submittedAnswer?.[0]?.files?.[0]?.name}
                </a>
              )}
            </Box>
          ) : (
            <>
              <input
                name="actUpload"
                id="contained-button-activityFile"
                type="file"
                accept=".pdf"
                ref={inputRef}
                onChange={handleFileChange}
                style={{ display: "none", pointerEvents: event }}
                multiple
              />
              <Box
                style={{
                  borderBottom: "2px solid #ced4da",
                  marginLeft: 20,
                  width: "100%",
                  fontSize: "14px",
                }}
              >
                {file?.name ? file.name : "Upload file"}
              </Box>
            </>
          )}
        </Box>
      )}

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
      {/* <RiskDrawer
        toggleDrawer={toggleDrawer}
        handleToggleRiskDrawer={handleToggleRiskDrawer}
        setRiskData={setRiskData}
        handleRiskData={handleRiskData}
        riskData={riskData}
      /> */}
    </Box>
  );
};

export default SingleChoiceWithMultiFeatures;
